import {
  salePayments,
  type PaymentDraft,
  type SalePaymentLine,
  type UseSalePayments,
} from "@/hooks/useSalePayments";
import { ADHOC_BUYER } from "./constants";

// Live walk 2, W2-6: every sale in the Daily Report was recorded on credit —
// a buyer who paid cash at the gate still showed as owing until someone
// recorded a receipt elsewhere. Each sale row now carries what was paid at the
// time of sale, sent with the sale as the Sales pages send it.

interface SaleRow {
  buyer_id: string;
  total_amount: string;
  payments?: PaymentDraft[];
}

/** The total the payload sends: whole rupees. */
export const saleTotal = (r: SaleRow): number => Math.round(parseFloat(r.total_amount) || 0);

/**
 * Whether a row takes "paid now" lines: a buyer on the books (a walk-in's sale
 * is already cash, and with no buyer there is no account to receive into) and
 * a total to pay against. The box, the Next check, the submit and the review
 * all ask this one question, so lines left on a row that no longer qualifies
 * are ignored everywhere rather than blocking Next from a hidden box.
 */
export const takesPayment = (r: SaleRow): boolean =>
  !!r.buyer_id && r.buyer_id !== ADHOC_BUYER && saleTotal(r) > 0;

/** The lines a row would send — none when it doesn't take payment. */
export const paidLines = (r: SaleRow): SalePaymentLine[] => (takesPayment(r) ? paidNow(r).buildLines() : []);

/** The split-tender model over a row's own payment lines. */
export function paidNow(
  r: SaleRow,
  onChange: (payments: PaymentDraft[]) => void = () => {},
): UseSalePayments {
  const lines = r.payments ?? [];
  return salePayments(lines, (update) => onChange(update(lines)), saleTotal(r));
}
